var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelChiar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#666",
    fill: "#666",
    cx: 7.273,
    cy: 10.909,
    r: 3.636
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    fill: "#FFF",
    cx: 7.273,
    cy: 10.909,
    r: 1.455
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#666",
    fill: "#FFF",
    cx: 14.182,
    cy: 13.455,
    r: 1.091
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.468.325h1.177a2 2 0 011.967 1.64l1.134 6.199h0M4.826 5.986h3.56A4 4 0 0112.137 8.6l1.014 2.748h2.222",
    stroke: "#666",
    strokeLinecap: "round"
  })))));
}
export default SvgWheelChiar;